import type { SVGProps } from 'react';
import { forwardRef, Ref } from 'react';

const SvgWarmtewisselaar1 = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 40 40"
    role="img"
    aria-hidden={true}
    ref={ref}
    {...props}
  >
    <path
      fill="#FFBFA5"
      d="M18 22.82c0-4.19 5.39-9.42 7.66-15.07a.36.36 0 0 1 .68 0C28.61 13.4 34 18.63 34 22.82a8 8 0 0 1-16 0"
    />
    <path
      fill="#FFBFA5"
      d="M17.85 15.75C21.19 19.08 22 24 19.28 26.69s-7.58 2.18-10.91-1.15z"
    />
    <path
      fill="#FF7842"
      d="M7.58 16.49a.52.52 0 0 1 .92.3 4.46 4.46 0 0 0 2.13 3.47S8 11.58 14.38 7.43a.4.4 0 0 1 .6.44 4.63 4.63 0 0 0 1.41 4.71c2.86 2.86 6.65 4.77 6.72 9.47A8.51 8.51 0 0 1 16 30.7a8.63 8.63 0 0 1-10.17-8.52 11.4 11.4 0 0 1 1.75-5.69m5.3 8.36a6.1 6.1 0 0 1-2.15 1.07.581.581 0 0 0-.16 1 6.28 6.28 0 1 0 6.88-10.46c.538.938.82 2 .82 3.08a6.27 6.27 0 0 1-3.79 5.77 4.22 4.22 0 0 0 .75-4.23 6.3 6.3 0 0 1-2.35 3.77M31.68 20a6 6 0 0 0-2.58-2.1.65.65 0 0 0-.7 1.06c.382.353.718.753 1 1.19a5.91 5.91 0 0 1 0 6.46 6.2 6.2 0 0 1-1 1.19.65.65 0 0 0 .7 1.06 6 6 0 0 0 2.58-2.1 6 6 0 0 0 0-6.76"
    />
    <path
      fill="#00215B"
      fillRule="evenodd"
      d="M23.65 23.58v-3h1v3z"
      clipRule="evenodd"
    />
    <path
      fill="#00215B"
      fillRule="evenodd"
      d="M25.65 22.58h-3v-1h3zM16.5 15V9h1v6z"
      clipRule="evenodd"
    />
    <path
      fill="#00215B"
      fillRule="evenodd"
      d="M20 12.5h-6v-1h6zM9 27.04H6v-1h3zM35 21.5h-4v-1h4z"
      clipRule="evenodd"
    />
  </svg>
);

/* eslint-disable import/no-default-export */
const ForwardRef = forwardRef(SvgWarmtewisselaar1);

export default ForwardRef;
